import React from 'react';
import { FormattedMessage } from 'react-intl';
import CheckCircleIcon from '@atlaskit/icon/glyph/check-circle';
import Heading from '@atlaskit/heading';

import inviteMessages from '../../../../../containers/InvitePage.messages';

import messages from '../../BasePage.messages';
import { HeaderWrapper, TitleWrapper } from './styled';
import { useWelcomeSubmission } from '../../hooks';

export const WelcomeHeader = () => {
  const { redirectType } = useWelcomeSubmission();

  switch (redirectType) {
    case 'signup':
    case 'resume_signup':
      return (
        <HeaderWrapper>
          <TitleWrapper>
            <Heading as={'h1'} size={'small'}>
              <FormattedMessage {...messages.emailVerifiedTitle} />
            </Heading>
            <CheckCircleIcon size="small" label="" />
          </TitleWrapper>
          <Heading as={'h2'} size={'xxsmall'}>
            <FormattedMessage {...messages.subheadingResumeSignup} />
          </Heading>
        </HeaderWrapper>
      );
    case 'invite':
      return (
        <Heading as={'h1'} size={'small'}>
          <FormattedMessage {...inviteMessages.inviteTitle} />
        </Heading>
      );
    case 'migration':
    case 'resume_migration':
      return (
        <Heading as={'h1'} size={'small'}>
          <FormattedMessage {...messages.subheadingMigration} />
        </Heading>
      );
    default:
      return (
        <Heading as={'h1'} size={'small'}>
          <FormattedMessage {...messages.subheadingResumeSignup} />
        </Heading>
      );
  }
};
